import { object, string, array, number, boolean } from 'yup';

import { Team } from '@/react/portainer/users/teams/types';

export function validationSchema(teams: Team[]) {
  return object().shape({
    name: string()
      .required('This field is required.')
      .test(
        'is-unique',
        'This team already exists.',
        (name) => !!name && teams.every((team) => team.Name !== name)
      ),
    leaders: array().of(number()),
    denyPortainerAccess: boolean(),
    addons: array().of(string()),
  });
}
